import { useContext } from 'react';
import { AlertNotificationContext } from './AlertNotificationContext';

export const useAlertNotifications = () => {
  const context = useContext(AlertNotificationContext);
  if (!context) {
    throw new Error('useAlertNotifications must be used within an AlertNotificationProvider');
  }
  return context;
};

